import { Button, Form, Select, DatePicker, Input } from 'antd';
import moment from 'moment';
import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionsComponent from 'src/components/shared/ActionsComponent';
import GridLayout from 'src/components/shared/gridLayout';

const CardFilters = (props) => {
    const { RangePicker } = DatePicker;
    const [form] = Form.useForm()
    const navigate = useNavigate()
    
    const disabledFutureDates = useCallback(
        (current) => current && current > moment().endOf('day'),
        []
      );
      
    useEffect(() => {
        if (props?.onloadGrid) {
            props.onloadGrid();
        }
    }, [props?.filterValues])
    const handleChange = useCallback((field) => (value) => {
        const trimmedValues = {
            ...form.getFieldsValue(),
            [field]: value
        };
        props?.filterObj(trimmedValues);
    }, [props, form]);
    const handleSearch = useCallback((values) => {
        let trimSearchData = values?.search?.trim();
        const invalidSearchPattern = /^[^\p{L}\p{N}]+$/u;
        if (!trimSearchData || invalidSearchPattern.test(trimSearchData)) {
            form.setFieldsValue({ ...values, search: null });
            props?.filterObj({ ...values, search: null });
            return;
        }
        const trimmedValues = {
            ...values,
            search: trimSearchData
        };
        props?.filterObj(trimmedValues);
    }, [props]);

    const handleAddCase = () => {
        if (!props?.selectedTransaction?.transactionId) {
            props?.handleError("Please select one record!")
            return;
        }
        navigate(`/cardtransactions/${props?.selectedTransaction?.transactionId}/createcase`);
    }
    const onActionClick = useCallback((key) => {
        handleToolBarActions(key)
    }, [props?.selectedTransaction?.transactionId])

    const handleToolBarActions = (action) => {
        switch (action) {
            case 'casesadd':
                handleAddCase()
                break;
            case 'exportexcel':
                props?.handleExcelExport()
                break;
            default:
                return;
        }
    }
    return (

        <div className='md:flex justify-between mb-4 mt-3 md:space-y-0 space-y-3'>

            <div>
                <Form className="custom-filter-field"
                    autoComplete="off"
                    onFinish={handleSearch}
                    form={form}>
                    <div className='grid md:grid-cols-3 gap-4'>
                        <Form.Item
                            name="Status"
                            className='!mb-0'
                        >
                            <Select
                                allowClear
                                className=""
                                placeholder={`All Transaction Status`}
                                onChange={handleChange("Status")}
                            >
                                {props?.stateLu?.map((item) => (
                                    <Option value={item?.name} key={item?.name}>{item?.name}</Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item name="dateRange" className='!mb-0' >
                            <RangePicker format="DD-MM-YYYY"
                                onChange={handleChange("dateRange")}
                                defaultValue={props?.currentDateRange}
                                disabledDate={disabledFutureDates}
                            />
                        </Form.Item>
                        <Form.Item
                            className='input-style !mb-0'
                            name="search"
                        >
                            <Input placeholder='Search by Email,Card Number,Trasction ID.'
                                suffix={<Button className='!bg-transparent border-none p-0 !hover:bg-transparent focus:bg-transparent focus:shadow-none' htmlType='submit'><span className="icon md search cursor-pointer"></span></Button>}
                                className="coin-search-input" maxLength={50} />
                        </Form.Item>
                    </div>
                </Form>
            </div>
            <div className='flex gap-2 justify-end items-center mt-3'>
                <ActionsComponent serviceName={"CardsManageService.Transactions"} onActionClick={onActionClick} />
                <GridLayout/>
            </div>
        </div>

    )
}
export default React.memo(CardFilters);